export const dict = {
    onLoadErrorTitle: 'Something went wrong',
    onLoadErrorText: 'Try refreshing the page.',
    noLiveGamesMessage: 'There are no live games available right now.',
    MiddleTermAt: 'at',
    MiddleTermVs: 'vs',
    refreshButtonText: 'Refresh',
    liveEventsAriaLabel: 'Live events',
    toggleSectionAriaLabel: 'Toggle section',
    viewEventAriaLabel: 'View event',
    sgpBadgeTitle: 'Open Event Page'
};
